import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../../components/Link';
import { NotFoundLinks } from '../../helpers/notFoundLinks';

import messages from '../../locale/messages';
import s from './NotFound.css';

function NotFound({ title }) {
  const siteName = useSelector((state) => state.siteSettings.data.siteName);
  const redirectionLinks = NotFoundLinks();

  return (
    <div className={s.notFoundContainer}>
      <div className={s.textCenter}>
        <h1 className={s.notFoundHeading}>
          <FormattedMessage {...messages.notFoundTitle} />
        </h1>
        <p className={s.headingSubText}>
          <FormattedMessage {...messages.notFoundSubTitle} />
        </p>
        <p className={s.errorCodeText}>
          <FormattedMessage {...messages.errorCode} />
        </p>
        <ul className={s.notFoundList}>
          <li>
            <FormattedMessage {...messages.linksTitle} />
          </li>
          {redirectionLinks?.map((item, key) => (
            <li key={key}>
              <Link to={item?.path}>
                <FormattedMessage {...messages?.[item?.label]} />&nbsp;
                {item?.isSite && siteName}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

NotFound.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(NotFound);
